<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="25%" :close-on-click-modal="false"
    @close="handleCloseAdd('addFormRef')">
    <el-form style="text-align: start;" ref="addFormRef" :model="form" :rules="rules" label-width="auto">
      <el-form-item label="文件夹名称" prop="filesName">
        <el-input v-model="form.filesName" size="mini"></el-input>
      </el-form-item>
      <el-form-item label="是否加密" prop="encryptFlag">
        <el-radio-group v-model="form.encryptFlag">
          <el-radio :label="1">加密</el-radio>
          <el-radio :label="0">不加密</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="加密密码" prop="password" v-if="form.encryptFlag == 1">
        <el-input v-model="form.password" size="mini" show-password></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="mini" plain @click="dialogVisible = false">取消</el-button>
      <el-button size="mini" type="primary" plain @click="handleAdd('addFormRef')">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import util from '@/untils/util'
import { postFilesAddFiles, putFilesUpdateFiles } from '../api.js'
export default {
  name: 'EditAddDialog',
  props: {
    title: {
      type: String,
      default: '新增文件夹',
    },
    dialog: {
      required: true,
      type: Boolean,
    },
    id: String,
    parentId: String,
    info: Object,
  },
  data() {
    return {
      projectId: util.session.get('groupId'),
      form: {
        filesName: '',
        encryptFlag: 0,
        password: '',
      },
      rules: {
        filesName: { required: true, message: '请输入文件夹名称', trigger: 'blur' },
        password: { required: true, message: '请输入密码', trigger: 'blur' },
      },
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
  },
  methods: {
    handleCloseAdd(type) {
      this.$refs[type].resetFields()

      this.form = {
        filesName: '',
        encryptFlag: 0,
        password: '',
      }

      this.$emit('close')
    },
    handleAdd(type) {
      this.$refs[type].validate((valid) => {
        if (!valid) return false

        this.handleSubmit()
      })
    },
    async handleSubmit() {
      try {
        const params = {
          groupId: this.projectId,
          filesType: '1',
          ...this.form,
          createBy: util.session.get('user').id,
          userType: util.session.get('roleId'),
          parentId: this.parentId || '0',
          id: this.id ? this.id : undefined,
        }

        if (this.id) {
          const { data: res } = await putFilesUpdateFiles(params)
          if (res.code == 200) {
            this.$message.success('修改成功')
            this.$emit('success')
            this.$emit('update:dialog', false)
          }
        } else {
          const { data: res } = await postFilesAddFiles(params)
          if (res.code == 200) {
            this.$message.success('添加成功')
            this.$emit('success')
            this.$emit('update:dialog', false)
          }
        }
      } catch (error) {
        this.$message.error(error)
      }
    },
  },
  watch: {
    dialog() {
      if (this.info) {
        this.form = {
          filesName: this.info.filesName,
          encryptFlag: Number(this.info.encryptFlag),
          password: this.info.oldPassword,
          oldPassword: this.info.oldPassword,
        }
      }
    },
  },
}
</script>

<style scoped lang="less"></style>
